import type { LoadingStep } from '../../types';

interface LoadingStepsProps {
  steps: LoadingStep[];
}

export default function LoadingSteps({ steps }: LoadingStepsProps) {
  return (
    <div className="loading-steps">
      {steps.map((step) => (
        <div
          key={step.id}
          className={`loading-step loading-step--${step.status}`}
        >
          <div className="loading-step__icon">
            {step.status === 'pending' && (
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10" />
              </svg>
            )}
            {step.status === 'active' && (
              <span className="loading-step__spinner" />
            )}
            {step.status === 'completed' && (
              <svg className="loading-step__check" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                <polyline points="20 6 9 17 4 12" />
              </svg>
            )}
          </div>
          <span className="loading-step__text">{step.label}</span>
        </div>
      ))}
    </div>
  );
}
